import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			category:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			selectedType:{ value: 'Institute', label: 'Institute'},
			selectedTypeValue:''		
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);

    }

	componentDidMount() {
	}

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}

		if(r == 'type'){
			this.setState({selectedType:selOption})
			this.setState({  selectedTypeValue : selOption.value});
		}

	};

   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });

  }
 
  
  handleSubmit = () => { 
	if(this.validateForm()){
	this.setState({Loading:true});
	const formdata = this.state;
	var qs = require('qs');
	var status, type = '';


	if(formdata.selectedvalue === ''){
	status =formdata.selectedOption.value;
	}else{
	status = formdata.selectedvalue;
	}

	if(formdata.selectedTypeValue === '' && formdata.selectedTypeValue!== 0){
		type =formdata.selectedType.value;
		}else{
		type = formdata.selectedTypeValue;
		}

	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		category : formdata.category,
		status: status,
		type:  type
	}

	let formData = new FormData();
	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}
	axios.post(apiUrl+"MembershipCategory/add",formData).then(res => {
		if(res.data.status === "success"){
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						setTimeout(
						function() {
							$('.success_message').html(this.props.navigate('/membershipcategory'));
						}
						.bind(this),
						3000
						);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				
				setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
				);
				this.setState({Loading:false});
			}
		});
		
	}
  }

  validateForm() {
	const {category} = this.state;
	const nameRegex = /^[A-Za-z\s]+$/;
	let errors = {};
	  let formIsValid = true;

	//   if(!category){
	// 	formIsValid = false;
	// 	$('.errorcategory').html('<span class="errorspan">Please fill the field</span>');
	// }else{
		
	// 	$('.errorcategory').html('');
	// }
	if (!category) {
		formIsValid = false;
		$('.errorcategory').html('<span class="errorspan">Please fill the field</span>');
	}else if(category){
		if (!nameRegex.test(category)) {
			formIsValid = false;
		$('.errorcategory').html('<span class="errorspan">Please enter the valid Category</span>');
		}else{
			$('.errorcategory').html('');
		}
		
	}	
	this.setState({
		errors: errors
	});
	return formIsValid;
}



  render() {
	const {selectedOption, selectedType} = this.state;

	
    return (
      <div className="wrapper"> 
 
	  <Header />
      <MenuSidebar currentpage="MembershipCategory" />  

	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div className="title">
				<h4>Add Subscription Category</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Category Name<span class="required" style={{ color: "red" }} >* </span></label>
				    <input type="text" name="category" onChange={this.handleInputChange} className="form-control" value={this.state.category}/>
					<div className="errorcategory"></div>
				</div>

				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} >* </span></label>
						   <Select 
						   name="status"
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
							isSearchable = {false}
							onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div> 

			</div>
                  
			<div className="form-right">
			
				<div className="form-group">					
					<label>Type<span class="required" style={{ color: "red" }} >* </span> </label>
						   <Select 
						   value={selectedType?selectedType:{ value: 'Institute', label: 'Institute'}}
                            options={lang.common.type_option} 
                            onChange={this.handleChange.bind(this, 'type')}
                            />
	           	</div> 			  
             

			</div>	
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>Adding</span>:<span>Submit</span>
                                        }
			   </button>
			 
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Add));